import React, { useEffect, useState } from 'react'
import { CButton, GeneralFilter, Loading } from '../../Components';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from '../Navbar/AdminNavbar';
import { Button, Form, InputGroup } from 'react-bootstrap';
import MakePagination from '../../Components/MakePagination';
import { urlPrefix } from '../../Helpers/Common';
import { AdminUpdateInquiryStatus,  getAdminInquiries } from '../Services/Cms';
import ConfirmationModal from '../Books/Components/ConfirmationModal';
import { toast } from 'react-toastify';
import { useDebounce } from '../../../CustomHooks/DebounceHook';

const ListInquiries = () => {
    const dropDownOptions = [{ id: 1, name: "pending", filter: "status" }, { id: 2, name: "completed", filter: "status" }]
    const [confirmationModal, setConfirmationModal] = useState({ show: false, data: null, acceptFx: null, rejectFx: null,message:null});
    const navigate = useNavigate()
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [inquiries, setInquiries] = useState([]);
    const [totalInquiries, setTotalInquiries] = useState(0);
    const [pageFilters, setPageFilters] = useState({})
    const [pagination, setPagination] = useState({ limit: 10, start_from: 0, search: null, order_by: [{ column: 'contact_us.id', order: 'desc' }] });
    const debouncedSearch = useDebounce(search,500);

    const selectFilter = (filter, data) => {
        if (filter === "order") {
            setPagination({ ...pagination, order_by: [data] })
        }
        else if (filter === "pagination") {
            setPagination({ ...pagination, start_from: data })
        }
        else if (filter === "search") {
            setPagination({ ...pagination, start_from: 0, search: data && data.length ? data.trim() : null })
        }
        else if (filter === "status") {
            if(data === "pending"){
                data = 1
            }
            else if(data === "completed"){
                data = 0
            }
            setPageFilters({ ...pageFilters, status: data })
            setPagination({ ...pagination, start_from: 0 })
        }
    }

    const inquiryStatusUpdate = async (data) => {
        const { id, status } = data
        setLoading(true)
        const result = await AdminUpdateInquiryStatus({ id, status:status === 1 ? 0 : 1 });
        if (result.success) {
            getInitialPageData()
            toast.success(result.message)
        }
        else {
            toast.error(result.error.message)
        }
        setConfirmationModal({ show: false, data: null, acceptFx: null, rejectFx: null ,message:null})
        setLoading(false)
    }

    const generalFilterFx = (option) => {
        selectFilter("status", option?.name)
    }

    const getInitialPageData = async () => {
        setLoading(true)
        const result = await getAdminInquiries({ ...pagination,filters: pageFilters, total_count_of: "contact_us.id" });
        setInquiries(result.data.inquiries)
        setTotalInquiries(result.data.totalInquiryRecords)
        setLoading(false)
    }

    useEffect(() => {
        getInitialPageData()
    }, [pagination,pageFilters])

    useEffect(()=>{ 
        selectFilter("search",search)
    },[debouncedSearch])

    return (
        <div className="admin-panel-main">
            <div className="panel-row">
                <div className="left">
                    <AdminNavbar></AdminNavbar>
                </div>
                <div className="right">
                    <div className="panel-title-top all-book">
                        <div className="top-left">
                            <h3 className="heading-h3">Inquiry list</h3>
                        </div>
                    </div>

                    <div className="dash-filter filter">
                        <div className="left-fil">
                            <GeneralFilter options={dropDownOptions} value="name" defaultValue="Status" fxToRun={generalFilterFx} clearText={"Select Status"} />
                        </div>
                        <div className="search">
                            <InputGroup className="admin-search-input" onChange={(e) => setSearch(e.target.value)} >
                                <Form.Control placeholder="Search name, email" value={search || ""} />
                            </InputGroup>
                        </div>
                    </div>

                    <div className="admin-panel-data">
                        <div className="top-title all-plans inquiries">
                            <div className="order-no">
                                <p className="top-t">Name</p>
                            </div>
                            <div className="title">
                                <p className="top-t">Email</p>
                            </div>
                            <div className="title">
                                <p className="top-t">Phone number</p>
                            </div>
                            <div className="title">
                                <p className="top-t">Query</p>
                            </div>
                            <div className="title t-center">
                                <p className="top-t">Status</p>
                            </div>
                        </div>
                        <div className="book-list">
                            {
                                inquiries && inquiries.length ?
                                    inquiries.map((inquiry) => 
                                    <div className="book-row all-plans inquiries" key={inquiry.id}>
                                        <div className="order-no-value">
                                            <p className="top-value">{inquiry.name}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{inquiry.email}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{inquiry.phone_number}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{inquiry.message}</p>
                                        </div>
                                        <div className="e-status-value">
                                            <button onClick={() => setConfirmationModal({
                                                show: true,
                                                data: { id: inquiry.id, status:inquiry.status },
                                                acceptFx:inquiryStatusUpdate,
                                                message:`Are you sure, you want to mark this inquiry as ${inquiry.status ? "Completed" : "Pending"}`,
                                                rejectFx: () => { setConfirmationModal({ show: false, data: null, acceptFx: null, rejectFx: null ,message:null}) }
                                            })} className={inquiry.status ? "toggle-on" : "toggle-off"}>
                                            </button>
                                            <div className="d-none">
                                                {
                                                    inquiry.status ? <div className="on">on</div> : <div className="off">of</div>
                                                }
                                            </div>
                                        </div>
                                    </div>) :
                                    <div className='no-data'>
                                        No Inquiries found.
                                    </div>
                            }
                            {
                                inquiries && inquiries.length ?
                                    <div className="books-pagination">
                                        <MakePagination totalRecords={totalInquiries} limiter={10} selectFilter={selectFilter}></MakePagination>
                                    </div> : null
                            }

                        </div>
                    </div>
                </div>
            </div>
            {
                loading ? <Loading /> : null
            }
            <ConfirmationModal confirmationModal={confirmationModal} />
        </div>
    )
}

export default ListInquiries
